//alert(jQuery);
//console.log(jQuery);


jQuery(document).ready(function($){

  var isTouch = ('ontouchstart' in document.documentElement);
  
  if (isTouch) {
    $(".img-prd-img").removeClass("sk-hover-second")
} else {
   $(".sk-hover-second[data-hover!='']").hover(
	  function() {
		$(this).attr("src",$(this).attr("data-hover"));
	  }, function() {
		$(this).attr("src",$(this).attr("data-main"));
	  }
	);
    $(window).scroll(function(){
            if ($(this).scrollTop() > 145) {
                $('body').addClass("neo-body-stick");
            } else {
                $('body').removeClass("neo-body-stick");
            }
        });
}
  
  

  $('.sk_read_more').click(function () {
        var collapse_content_selector = $(this).attr('href');
        var toggle_switch = $(this);
        
		$(collapse_content_selector).toggle(400,function () {
		  if ($(this).css('display') == 'none') {
				if(toggle_switch.attr("data-readmore") != "")
					toggle_switch.html(toggle_switch.attr("data-readmore"));
				else
					toggle_switch.html('Read More &raquo;');
				
            } else {
			 
			if(toggle_switch.attr("data-readless") != "")
					toggle_switch.html(toggle_switch.attr("data-readless"));
				else
					toggle_switch.html('Read Less &raquo;');
            }
        });
		
		return false;
    });


  $(".slick-slider").not(".slick-initialized").slick({
          dots: false,
          infinite: true,
          variableWidth: false,
          slidesToShow: 1,
          autoplay: true,       
          autoplaySpeed: 0,
          speed: 8000,
          pauseOnHover: false,
          cssEase: 'linear'
        });
  
    $(".slick-slider-mobile").not(".slick-initialized").slick({
          dots: false,
          infinite: true,
          variableWidth: false,
          slidesToShow: 2,
          autoplay: true, 
          autoplaySpeed: 0,
          speed: 1000,
          cssEase: 'linear'
          //autoplaySpeed: 0,
          //speed: 80000,
         // pauseOnHover: false,
        //  cssEase: 'linear'
        });
  
  
});